// eslint-disable-next-line no-unused-vars
import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import markerwithlabel from 'markerwithlabel';
import {LANDINGAPP_MARKER_ICON} from '../../../utils/markers';

import './PriceMarker.less';

const PriceMarker = ({map, className: labelClass, position, content}) => {
    const MarkerWithLabel = markerwithlabel(google?.maps);
    const marker = new MarkerWithLabel({
        position,
        map,
        labelContent: content,
        labelClass,
        icon: LANDINGAPP_MARKER_ICON.PRICE,
    });

    useEffect(() => {
        return () => {
            marker.setMap(null);
        };
    });
    return null;
};

PriceMarker.propTypes = {
    className: PropTypes.string,
    content: PropTypes.string,
    isClickable: PropTypes.bool,
    map: PropTypes.object, // eslint-disable-line react/forbid-prop-types
    position: PropTypes.shape({
        lat: PropTypes.number,
        lng: PropTypes.number,
    }),
    showZone: PropTypes.bool,
    zIndex: PropTypes.number,
    zoneOptions: PropTypes.shape({
        fillColor: PropTypes.string,
        fillOpacity: PropTypes.number,
        radius: PropTypes.number,
        strokeColor: PropTypes.string,
        strokeOpacity: PropTypes.number,
        strokeWeight: PropTypes.number,
        visible: PropTypes.bool,
    }),
};

export default PriceMarker;
